






































































































import Vue from "vue";
import { authentication } from "@/stores";
import { Route } from "vue-router";
import { Announcement } from "@/models";
import { firestore } from "firebase/app";
import firebaseProject from "@/common/firebaseProject";
import { Collection, Document, List, DocDataRef } from "@/stores";
import { createUser, updateUser, updatePassword } from "@/stores/userUtil";
import { form, autoclose, shopBase } from "@/mixins";
import { alert, confirm } from "@/services/dialog";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import { default as loadImage, parseMetaData } from "blueimp-load-image";
import { v4 as Uuidv4 } from "uuid";
import dayjs from "dayjs";

const db = firebaseProject.firestore();

export default shopBase.extend(Vue).extend({
  name: "AnnounceDetail",
  mixins: [form],
  components: { VueCtkDateTimePicker },
  data() {
    return {
      authentication,
      transitionName: "",
      justifyNow: false,
      html: ""
    };
  },
  async created() {
    const docId = this.$route.params.id;
    if (docId) {
      const _doc = await this.document.ref?.get();
      if (_doc) {
        this.html = _doc.data()?.content || "";
      }
    }
  },
  computed: {
    collection(): Collection<Announcement> {
      const path = `/shop/${this.shopId}/announcement`;
      return new Collection(
        db.collection(path) as firestore.CollectionReference<Announcement>
      );
    },
    document(): Document<Announcement> {
      const id = this.$route.params.id;
      return this.collection.doc(id, { noListen: true });
    }
  },
  methods: {
    setNow() {
      this.document.effective.discloseAt = this.formatFullDate(this.now);
      this.justifyNow = true;
    },
    async register() {
      if (this.document.effective.content != this.html) {
        this.document.effective.content = this.html;
      }
      if (this.document.canSave) {
        this.document.effective.viewableTenant = ["all"];
        const result = await this.document.save().catch(e => {
          alert({
            title: "エラー",
            text: "お知らせの保存に失敗しました。"
          });
        });
        if (result) {
          this.$router.push("/announce");
        }
      } else {
        this.$router.push("/announce");
      }
    },
    async registerAndPublish() {
      if (!this.document.effective.discloseAt) {
        alert({
          title: "エラー",
          text: "配信開始日時が設定されていません。"
        });
      } else {
        this.document.effective.publishStatus = 2;
        await this.register();
      }
    },
    async deleteDocument() {
      const result = await this.document.remove();
      if (result && result.successed) {
        this.$router.push("/announce");
      } else {
        alert({
          title: "エラー",
          text: "削除できませんでした。"
        });
      }
    }
  }
});
